import { SovosGrid, SovosIcon, SovosTypography } from "mosaic-react";
import { CircleRounded } from "mosaic-react-icons";
import { useGlobalValue } from "colbi_web_ui/lib/state/GlobalProvider";
import { ActionButtonOutlined } from "../../../DetailPanels/GeneratorListDetails/ActionButtonOutlined";

const GeneratorAuditStatus = (props) => {
    const { i18n } = useGlobalValue();
    const { value: cell } = props || {};
    const { auditStatus, uncheckedDescription, history, link } = cell || {};

    if (auditStatus === null || auditStatus === undefined) {
        return (
            <SovosGrid
                sx={{
                    display: "flex",
                    justifyContent: "flex-start",
                    flexGrow: "0",
                    alignItems: "center",
                    minWidth: "150px",
                }}
            >
                <SovosIcon sx={{ marginRight: "10px", fontSize: "12px", color: (theme) => theme.palette.grey[300] }}>
                    <CircleRounded sx={{ 
                        color: (theme) => theme.palette.grey[300], 
                        fontSize: "12px", 
                        position: "relative", 
                        left: "50%", 
                        //top: "50%", 
                        transform: "translate(-50%, -50%)" }} />
                </SovosIcon>
                <SovosTypography variant="body1" sx={{ fontSize: "12px" }}>{uncheckedDescription ? i18n`${uncheckedDescription}` : i18n`Unchecked`}</SovosTypography>
            </SovosGrid>
        );
    }

    if (!auditStatus) {
        return (
            <SovosGrid
                sx={{
                    display: "flex",
                    justifyContent: "flex-start",
                    flexGrow: "0",
                    alignItems: "center",
                    minWidth: "150px",
                }}
            >
                <SovosIcon color={"success"} sx={{ marginRight: "10px", fontSize: "12px" }}>
                    <CircleRounded sx={{ 
                        color: "success", 
                        fontSize: "12px", 
                        position: "relative", 
                        left: "50%", 
                        //top: "50%", 
                        transform: "translate(-50%, -50%)" }} />
                </SovosIcon>
                <SovosTypography variant="body1" sx={{ fontSize: "12px" }}>{i18n`Checked`}</SovosTypography>
            </SovosGrid>
        );
    }

    return (
        <SovosGrid
            sm={"auto"}
            sx={{ display: "flex", justifyContent: "flex-end", alignItems: "center" }}
        >
            <SovosGrid
                sm={"auto"}
                sx={{
                    display: "flex",

                    alignItems: "center",
                }}
            >
                <SovosIcon color={"error"} sx={{ marginRight: "10px", fontSize: "12px" }}>
                    <CircleRounded sx={{ 
                        color: "error", 
                        fontSize: "12px", 
                        position: "relative", 
                        left: "50%", 
                        //top: "50%", 
                        transform: "translate(-50%, -50%)" }} />
                </SovosIcon>
                <ActionButtonOutlined
                    history={history}
                    link={link}
                    title={"Check audit result"}
                    i18n={i18n}
                    sx={{ marginLeft: "0px !important", paddingLeft: "0px !important", fontSize: "12px" }}
                    variant="text"
                />
            </SovosGrid>
        </SovosGrid>
    );
};

export default GeneratorAuditStatus;
